import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ClipboardCopyService {

  public recentlyCopiedFrom = false;

  public get copyButtonText() {
    return this.recentlyCopiedFrom ? 'Copied!' : 'Copy';
  }

  public copyToClipboard(data: string | undefined) {
    navigator.clipboard.writeText(data ?? 'undefined');
    this.recentlyCopiedFrom = true;
    setTimeout(() => this.recentlyCopiedFrom = false, 2500);
  }
}
